import React, { useState, useRef, useContext } from 'react'
import ReCAPTCHA from "react-google-recaptcha";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { data } from "../../config/config.js"
import { useTranslation } from 'react-i18next';
import { globalContext } from '../Context/GlobalContext';
import RegField from '../StepForm/RegField';
import '../StepForm/RegUsa.css';
import "./FormularioStyle.css"

const apiContacto = process.env.REACT_APP_API_CONTACTO;

// Mismo límite que el backend para el CV
const MAX_CV_BYTES = 5 * 1024 * 1024;

export const Formulario = () => {
    const [usuarioValido, setUsuarioValido] = useState(false);
    const [nombreCv, setNombreCv] = useState('');
    const [values, setValues] = useState({
        nombre: '',
        mensaje: '',
        email: '',
        telefono: '',
    })
    const [t] = useTranslation("global")
    const { colorTheme } = useContext(globalContext)
    const captcha = useRef(null)

    const handleInputChange = (e) => {
        setValues({
            ...values,
            [e.target.name]: e.target.value
        })
    }

    // El input de archivo no es controlado: solo se guarda el nombre para mostrarlo
    const handleFileChange = (e) => {
        const archivo = e.target.files && e.target.files[0];
        if (!archivo) {
            setNombreCv('');
            return;
        }
        if (archivo.size > MAX_CV_BYTES) {
            Swal.fire({
                icon: 'warning',
                title: t("trabajaConNosotros.archivo-grande"),
            });
            e.target.value = '';
            setNombreCv('');
            return;
        }
        setNombreCv(archivo.name);
    }

    const onChange = () => {
        if (captcha.current.getValue()) {
            console.log("El usuario no es un robot");
            setUsuarioValido(true);
        }
    };

    const handleSubmit = (e) => {
        if (captcha.current.getValue()) {
            Swal.fire({
                title: 'Procesando su solicitud',
                html: 'Espere por favor',
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            });
        }
        else {
            e.preventDefault();
            Swal.fire({
                icon: 'error',
                title: 'Debes realizar la verificacion de seguridad!',
                showConfirmButton: true,
            })
        }
    }

    return (
        <div className={`reg-usa${colorTheme === 'dark' ? ' reg-usa--dark' : ''}`}>

            <div className="reg-header">
                <h1 className="reg-header__title">{t("trabajaConNosotros.titulo")}</h1>
                <p className="reg-header__sub">{t("trabajaConNosotros.subtitulo")}</p>
            </div>

            <div className="reg-card">
                <form
                    className="reg-form"
                    action={`${apiContacto}/cv`}
                    encType="multipart/form-data"
                    method="POST"
                    onSubmit={handleSubmit}
                >
                    <div className="reg-section">
                        <h2 className="reg-section__title">
                            <i className="fa-solid fa-user" aria-hidden="true" />
                            {t("trabajaConNosotros.seccion-datos")}
                        </h2>

                        <div className="reg-grid">
                            <RegField id="trabaja-nombre" label={t("formulario.label-1")} icon="fa-id-card" full>
                                <input
                                    id="trabaja-nombre"
                                    className="reg-field__input"
                                    name="nombre"
                                    value={values.nombre}
                                    onChange={handleInputChange}
                                    placeholder={t("formulario.placeholder-1")}
                                    type="text"
                                    autoComplete="name"
                                    maxLength={50}
                                    required
                                />
                            </RegField>

                            <RegField id="trabaja-email" label={t("formulario.label-2")} icon="fa-envelope">
                                <input
                                    id="trabaja-email"
                                    className="reg-field__input"
                                    name="email"
                                    value={values.email}
                                    onChange={handleInputChange}
                                    placeholder={t("formulario.placeholder-2")}
                                    type="email"
                                    autoComplete="email"
                                    maxLength={50}
                                    required
                                />
                            </RegField>

                            <RegField id="trabaja-telefono" label={t("formulario.label-3")} icon="fa-phone">
                                <input
                                    id="trabaja-telefono"
                                    className="reg-field__input"
                                    name="telefono"
                                    value={values.telefono}
                                    onChange={handleInputChange}
                                    placeholder={t("formulario.placeholder-3")}
                                    type="tel"
                                    inputMode="tel"
                                    autoComplete="tel"
                                    maxLength={30}
                                    required
                                />
                            </RegField>

                            <RegField id="trabaja-mensaje" label={t("formulario.label-4")} icon="fa-message" full>
                                <textarea
                                    id="trabaja-mensaje"
                                    className="reg-field__input reg-field__input--textarea"
                                    name="mensaje"
                                    value={values.mensaje}
                                    onChange={handleInputChange}
                                    placeholder={t("formulario.placeholder-4")}
                                    rows={4}
                                    maxLength={300}
                                />
                            </RegField>
                        </div>
                    </div>

                    <div className="reg-section">
                        <h2 className="reg-section__title">
                            <i className="fa-solid fa-file-lines" aria-hidden="true" />
                            {t("trabajaConNosotros.seccion-cv")}
                        </h2>

                        <label
                            className={`work-file${nombreCv ? ' work-file--filled' : ''}`}
                            htmlFor="archivo"
                        >
                            <i
                                className={`fa-solid ${nombreCv ? 'fa-circle-check' : 'fa-cloud-arrow-up'} work-file__icon`}
                                aria-hidden="true"
                            />
                            <span className="work-file__title">
                                {nombreCv ? t("formulario.cv-attached") : t("formulario.attach-cv")}
                            </span>
                            <span className="work-file__name">
                                {nombreCv || t("formulario.formato-archivo")}
                            </span>
                            <input
                                id="archivo"
                                name="archivo"
                                type="file"
                                accept=".pdf,.doc,.docx"
                                required
                                className="work-file__input"
                                onChange={handleFileChange}
                            />
                        </label>
                    </div>

                    <div className="reg-captcha">
                        <ReCAPTCHA
                            onChange={onChange}
                            ref={captcha}
                            sitekey={data.sitekey}
                        />
                    </div>

                    <div className="reg-actions">
                        <button
                            type="submit"
                            className="reg-btn reg-btn--primary"
                            disabled={!usuarioValido}
                        >
                            {t("formulario.btn-enviar")}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}
